// src/components/homepage_content/SportLists.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MatchCard from './MatchCard';

const SportLists = () => {
  const [sports, setSports] = useState([]);
  const [selectedSport, setSelectedSport] = useState('football');
  const [matches, setMatches] = useState([]);
  const navigate = useNavigate();

  // Demo sports data
  const demoData = {
    football: [
      {
        id: 'fb-1',
        homeTeam: 'Liverpool',
        awayTeam: 'Chelsea',
        league: 'Premier League',
        sport: 'football',
        time: new Date(Date.now() + 86400000).toISOString(), // Tomorrow
        odds: {
          home: 2.20,
          draw: 3.30,
          away: 3.20
        }
      },
      {
        id: 'fb-2',
        homeTeam: 'PSG',
        awayTeam: 'Marseille',
        league: 'Ligue 1',
        sport: 'football',
        time: new Date(Date.now() + 172800000).toISOString(), // 2 days
        odds: {
          home: 1.50,
          draw: 4.00,
          away: 6.50
        }
      }
    ],
    basketball: [
      {
        id: 'bb-1',
        homeTeam: 'LA Lakers',
        awayTeam: 'Golden State',
        league: 'NBA',
        sport: 'basketball',
        time: new Date(Date.now() + 10800000).toISOString(), // 3 hours
        odds: {
          home: 1.90,
          away: 1.90
        }
      }
    ],
    tennis: [
      {
        id: 'tn-1',
        homeTeam: 'Djokovic',
        awayTeam: 'Nadal',
        league: 'ATP Finals',
        sport: 'tennis',
        time: new Date(Date.now() + 18000000).toISOString(), // 5 hours
        odds: {
          home: 1.65,
          away: 2.25
        }
      }
    ]
  };

  const sportCategories = [
    { id: 'football', name: '⚽ Football', count: 124 },
    { id: 'basketball', name: '🏀 Basketball', count: 47 },
    { id: 'tennis', name: '🎾 Tennis', count: 32 },
    { id: 'cricket', name: '🏏 Cricket', count: 18 },
    { id: 'esports', name: '🎮 Esports', count: 56 },
  ];

  useEffect(() => {
    setMatches(demoData[selectedSport] || []);
  }, [selectedSport]);

  return (
    <div className="bg-gray-900 rounded-xl p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-white">Popular Sports</h2>
        <button
          onClick={() => navigate('/sports')}
          className="text-blue-400 hover:text-blue-300 text-sm font-medium"
        >
          All Sports →
        </button>
      </div>

      {/* Sport Categories */}
      <div className="flex space-x-2 mb-6 overflow-x-auto pb-2 pr-4">
  {sportCategories.map(sport => (
    <button
      key={sport.id}
      onClick={() => setSelectedSport(sport.id)}
      className={`flex items-center space-x-2 px-4 py-2 rounded-lg whitespace-nowrap transition-colors flex-shrink-0 ${
        selectedSport === sport.id
          ? 'bg-blue-600 text-white'
          : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
      }`}
    >
      <span>{sport.name.split(' ')[0]}</span>
      <span className="text-xs bg-gray-900 px-2 py-0.5 rounded">
        {sport.count}
      </span>
    </button>
  ))}
</div>

      {/* Matches */}
      <div className="space-y-4">
        {matches.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-400">No matches available for this sport</p>
          </div>
        ) : (
          matches.map(match => (
            <MatchCard key={match.id} match={match} />
          ))
        )}
      </div>

      {/* Quick Navigation */}
      <div className="mt-6 pt-6 border-t border-gray-800">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <button
            onClick={() => navigate('/sports')}
            className="p-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-center transition-colors"
          >
            <div className="text-2xl mb-1">⚽</div>
            <div className="text-sm font-medium text-white">All Sports</div>
          </button>
          <button
            onClick={() => navigate('/live')}
            className="p-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-center transition-colors"
          >
            <div className="text-2xl mb-1">🔥</div>
            <div className="text-sm font-medium text-white">Live Betting</div>
          </button>
          <button
            onClick={() => navigate('/casino')}
            className="p-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-center transition-colors"
          >
            <div className="text-2xl mb-1">🎰</div>
            <div className="text-sm font-medium text-white">Casino</div>
          </button>
          <button
            onClick={() => navigate('/betslip')}
            className="p-3 bg-gray-800 hover:bg-gray-700 rounded-lg text-center transition-colors"
          >
            <div className="text-2xl mb-1">📋</div>
            <div className="text-sm font-medium text-white">My Betslip</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SportLists;